export default __webpack_public_path__ + "0346344bb359b45a89243128b86c67c0.png";